<template>
  <div>
    <!-- 详情 -->
    <van-popup v-model:show="modalVisible" position="bottom" closeable :style="{width:'100%', height: '100%'}" class="sheet_common">
      <div class="sheet_wrap discount_detail">
        <h1 class="sheet_title">{{ modalTitle }}详情</h1>
        <div class="sheet_content">
          <van-row>
            <van-col span="7" class="text-right">名称：</van-col>
            <van-col span="17">{{ modalData.name }}</van-col>
          </van-row>
          <van-row>
            <van-col span="7" class="text-right">描述：</van-col>
            <van-col span="17">{{ modalData.desc }}</van-col>
          </van-row>
          <van-row v-if="modalType === 'vip'">
            <van-col span="7" class="text-right">会员权益：</van-col>
            <van-col span="17">{{ modalData.discount }}</van-col>
          </van-row>
          <van-row v-if="modalType === 'vip'">
            <van-col span="7" class="text-right">价格：</van-col>
            <van-col span="17">
              {{ modalData.promote_price }}
              <span v-if="modalType === 'vip' && modalData.origin_price != null" style="text-decoration:line-through;color:#999;font-size: 12px;">¥ {{ modalData.origin_price }}</span>
            </van-col>
          </van-row>
          <van-row v-if="modalType === 'coupons'">
            <van-col span="7" class="text-right">优惠方式：</van-col>
            <van-col span="17">{{ modalData.discount }}</van-col>
          </van-row>
          <van-row v-if="modalType === 'coupons' && modalData.user_limit >0 ">
            <van-col span="7" class="text-right">每人限领用：</van-col>
            <van-col span="17">{{ modalData.user_limit }}张</van-col>
          </van-row>
          <van-row v-if="modalType === 'coupons' && modalData.user_limit == 0 ">
            <van-col span="7" class="text-right">每人限领用：</van-col>
            <van-col span="17">不限领取数量</van-col>
          </van-row>
          <van-row>
            <van-col span="7" class="text-right">使用有效期：</van-col>
            <van-col span="17">{{ modalData.expired_desc }}</van-col>
          </van-row>
          <van-row>
            <van-col span="7" class="text-right">权益说明：</van-col>
            <van-col span="17">{{ modalData.rights_tips }}</van-col>
          </van-row>
          <van-row>
            <van-col span="7" class="text-right">领取须知：</van-col>
            <van-col span="17">{{ modalData.receive_tips }}</van-col>
          </van-row>
          <van-row>
            <van-col span="7" class="text-right">使用须知：</van-col>
            <van-col span="17">{{ modalData.instructions }}</van-col>
          </van-row>
          <van-row>
            <van-col span="7" class="text-right">适用范围：</van-col>
            <van-col span="17">
              <span v-if="modalData.cur_scope == 'assign'"> 指定课程（{{ data.cur_scope_detail.length }}个） </span>
              <span v-else>全部课程</span>
            </van-col>
          </van-row>
          <van-row v-if="modalData.cur_scope == 'assign'">
            <van-col span="24">
              <table class="table_common">
                <colgroup>
                  <col />
                  <col width="30%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>课程名称</th>
                    <th>价格</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(itemTr, indexTr) in data.cur_scope_detail" :key="indexTr">
                    <td>
                      {{ itemTr.name }}
                    </td>
                    <td>
                      ¥ {{ itemTr.price }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </van-col>
          </van-row>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import ElDescription from 'components/common/el-descriptions/ElDescription'
  import ElDescriptionItem from 'components/common/el-descriptions/ElDescriptionItem'
  export default {
    components: {
      ElDescription,
      ElDescriptionItem
    },
    props: {
      visible: Boolean,
      title: String,
      data: Object,
      type: String
    },
    data() {
      return {
        modalVisible: this.visible,
        modalTitle: this.title,
        modalData: this.data,
        modalType: this.type,
      }
    },
    mounted() {
    },
    watch: {
      visible(val) {
        this.modalVisible = val;
      },
      title(val) {
        this.modalTitle = val;
      },
      type(val) {
        this.modalType = val;
      },
      data(val) {
        this.modalData = val;
      },
      modalVisible(val) {
        this.$emit('update:visible', val);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .discount_detail {
    .van-row {
      margin-bottom:10px;
      line-height:1.5;
    }
  }
</style>
